// Note
// el === product filter value
// value === filter value
const predicates = {
    eq: value => el => String(el) === String(value),
    eqManyToOne: value => el => {
        if (Array.isArray(el)) {
            if (Array.isArray(value)) {
                for (let i = 0; i < el.length; i++) {
                    const filterItem = el[i];

                    if (value.includes(String(filterItem))) {
                        return true;
                    }
                }
            }
        } else {
            return Array.isArray(value) ? value.includes(String(el)) : null;
        }
    },
    eqOneToMany: value => el => {
        return el.includes(value);
    },
    gte: value => el => Number(`${el}`.replace(',', '.')) >= Number(value),
    lte: value => el => Number(`${el}`.replace(',', '.')) <= Number(value),
};

export const filterItems = (query, items) => {
    const fields = Object.keys(query);

    const activeFields = fields.filter(field => {
        if (query[field]) {
            if (Array.isArray(query[field])) {
                return query[field].length ? query[field] : null;
            }

            return query[field];
        }

        return null;
    });

    const result = activeFields.reduce((acc, field) => {
        const [name, predicateName] = field.split('_');
        const match = predicates[predicateName];

        return acc.filter(item => {
            return match(query[field])(item.filterProps[name]);
        });
    }, items);

    return result;
};
